var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckmark = function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m21.873 6.621-2.479-2.494a.44.44 0 0 0-.62 0L8.325 14.637a.44.44 0 0 1-.62 0l-2.48-2.493a.44.44 0 0 0-.619 0l-2.48 2.494a.447.447 0 0 0 0 .623l5.58 5.612a.44.44 0 0 0 .62 0L21.872 7.245a.446.446 0 0 0 0-.624"
  })));
};
export default SvgCheckmark;